import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import ModalDefault from './modal-default';

class ModalConfirm extends React.PureComponent {
  render() {
    return (
      <ModalDefault isOpen={this.props.isOpen} onCancel={this.props.onCancel}>
        <div className="glu-modal__header">
          <div className="glu-modal__title glu-flex-grow">Confirm Changes</div>
          <div className="glu-flex-shrink">
            <button
              aria-label="close"
              type="button"
              className="glu-btn-link g-icon g-icon-close"
              onClick={this.props.onCancel}
            />
          </div>
        </div>
        <div className="glu-modal__body">
          <div className="glu-content__section">
            {this.props.children ? this.props.children : 'Are you sure you want to save changes?'}
          </div>
        </div>
        <footer className="glu-modal__footer glu-flex-row">
          <div className="glu-flex-grow glu-flex-row glu-flex-align-center">
            <div className="glu-flex-grow text-right">
              <button onClick={this.props.onCancel} className="glu-btn glu-btn--secondary">
                Cancel
              </button>
            </div>
            <div className="glu-flex-shrink">
              <button onClick={this.props.onConfirm} className="glu-btn glu-btn--primary">
                Confirm
              </button>
            </div>
          </div>
        </footer>
      </ModalDefault>
    );
  }
}

ModalConfirm.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemLabel: PropTypes.string,
};

ModalConfirm.defaultProps = {
  children: null,
  isOpen: false,
  itemLabel: '',
};

export default ModalConfirm;
